// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"707":"039768ef","750":"8abf1f9a"}[chunkId] + ".chunk.js";
};